import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { transparentize } from '../../Constants/Colors';
import styled from 'styled-components';
import { CombineClasses } from '../../Utility/ReactUtils';
export var ValidationDisplay;
(function (ValidationDisplay) {
    ValidationDisplay["ErrorsOnly"] = "ErrorsOnly";
    ValidationDisplay["ErrorsAndSuccess"] = "ErrorsAndSuccess";
})(ValidationDisplay || (ValidationDisplay = {}));
export var ValidationState;
(function (ValidationState) {
    ValidationState[ValidationState["None"] = 0] = "None";
    ValidationState[ValidationState["Valid"] = 1] = "Valid";
    ValidationState[ValidationState["Invalid"] = 2] = "Invalid";
})(ValidationState || (ValidationState = {}));
export default function ValidationSection(props) {
    const { validation, validationDisplay, validationSuccessMessage, helperText, className } = props;
    const displaySuccess = validationDisplay === ValidationDisplay.ErrorsAndSuccess;
    const showSuccessMessage = validation?.isValid && displaySuccess && validationSuccessMessage;
    const showValidationSection = validation?.errors.length || helperText || showSuccessMessage;
    if (!showValidationSection) {
        return null;
    }
    return (_jsxs(StyledValidationSection, { className: CombineClasses(className, 'validation-section'), children: [helperText ? _jsx(HelperText, { children: helperText }) : null, showSuccessMessage ? (_jsx(ValidationSuccessMessage, { children: validationSuccessMessage })) : null, validation?.errors.map((error, i) => _jsx(ValidationError, { children: error }, i))] }));
}
export function getValidationState(validationDisplay, validation) {
    const displaySuccess = validationDisplay === ValidationDisplay.ErrorsAndSuccess;
    let validationState = ValidationState.None;
    if (validation?.errors.length) {
        validationState = ValidationState.Invalid;
    }
    else if (displaySuccess && validation?.isValid) {
        validationState = ValidationState.Valid;
    }
    return validationState;
}
const HelperText = styled.span ``;
const ValidationSuccessMessage = styled.span ``;
const ValidationError = styled.span ``;
const StyledValidationSection = styled.section `
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.spacing.xs};
	margin-top: ${(props) => props.theme.spacing.xs};
	font-size: ${(props) => props.theme.typography.sm};

	${HelperText} {
		color: ${(props) => transparentize(props.theme.secondary, 0.3)};
	}

	${ValidationError} {
		color: ${(props) => props.theme.palette.error};
	}

	${ValidationSuccessMessage} {
		color: ${(props) => props.theme.palette.success};
	}
`;
//# sourceMappingURL=ValidationSection.js.map